// 递归查找菜单
export function findMenuByUrl(menuList, url) {
  for (let item of menuList) {
    if (item.url === url) return item;
    if (item.children && item.children.length) {
      const found = findMenuByUrl(item.children, url);
      if (found) return found;
    }
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/utils/menu.js